import { NavLink } from "react-router-dom";

const items = [
  { to: "/", label: "首页", icon: "⌂", end: true },
  { to: "/explore", label: "拓展", icon: "⌁" },
  { to: "/me", label: "我的", icon: "◌" }
];

export function BottomNav() {
  return (
    <nav className="bottom-nav" aria-label="主导航">
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => isActive ? "is-active" : undefined}>
          <span>{item.icon}</span><b>{item.label}</b>
        </NavLink>
      ))}
    </nav>
  );
}
